/* ================================================================================ */
/** ====================================
 * 変数
 * */
const header = document.querySelector(".l-header");
const navBtn = document.querySelector(".nav-btn");
const navBtns = document.querySelectorAll(".nav-btn");
const globalNav = document.querySelector(".global-nav");
const navCompanyMark = document.querySelector(".nav__company-mark");
const navCompanyMarkBg = document.querySelector(".nav__company-mark__bg");
const navContent = document.querySelector(".nav__inner");
const navFadeInItem = document.querySelector(".navFadeIn");
/* ================================================================================ */
/** ====================================
 * header__交差オブザーバー
 * */
function init() {
  let headerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.05,
  };
  const headerObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        $(".l-header").removeClass("l-header__active");
      } else {
        $(".l-header").addClass("l-header__active");
      }
    });
  }, headerOptions);

  let target = document.querySelector(".kv");
  if (target) {
    headerObserver.observe(target);
  }

  let lastScrollTop = 0;
  window.addEventListener("scroll", function () {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop) {
      // 下方向スクロール
      gsap.to(".l-header", { y: -100, opacity: 0, duration: 0.3 });
    } else {
      // 上方向スクロール
      gsap.to(".l-header", { y: 0, opacity: 1, duration: 0.3 });
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
}
window.onload = init;
/* ================================================================================ */
/** ====================================
 * nav肉球アニメーション
 * */
function navAnime01() {
  const navPaws = gsap.timeline();

  navPaws
    .set(navCompanyMark, {
      autoAlpha: 0,
      scale: 1,
    })

    .set(navCompanyMarkBg, {
      autoAlpha: 0,
      scale: 1,
    })

    .set(navContent, {
      autoAlpha: 0,
      y: 30,
    })

    .to(navCompanyMark, {
      autoAlpha: 1,
      duration: 0.4,
      delay: 0.2,
    })

    .to(navCompanyMarkBg, {
      scale: 7,
      ease: "bounce.out",
      duration: 1,
      delay: 1,
      opacity: 0.8,
      visibility: "visible",

      onStart: () => {
        gsap.to(navCompanyMark, {
          autoAlpha: 0,
          duration: 0.25,
          ease: "power4.out",
        });
      },
    });

  return navPaws;
}
/* ================================================================================ */
/** ====================================
 * nav中身アニメーション
 * */
function navAnime02() {
  const navInner = gsap.timeline();

  navInner
    .set(".navFadeIn", {
      autoAlpha: 0,
      y: 30,
    })

    .to(navContent, {
      y: 0,
      autoAlpha: 1,
      ease: "power1.out",
      zIndex: 1000,
    })

    .to(".navFadeIn", 1.2, {
      y: 0,
      autoAlpha: 1,
      ease: "expo.out",
      stagger: {
        each: 0.1,
        from: "start",
      },
    });

  return navInner;
}
navBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    globalNav.classList.toggle("is-open");

    navBtns.forEach((b) => b.classList.toggle("is-open"));

    gsap.killTweensOf([
      navCompanyMark,
      navCompanyMarkBg,
      navContent,
      ".navFadeIn",
    ]);

    gsap.set([navCompanyMark, navCompanyMarkBg, navContent, ".navFadeIn"], {
      clearProps: "opacity, transform",
    });

    const navAnime = gsap.timeline().add(navAnime01()).add(navAnime02());
  });
});
document.querySelectorAll(".global-nav a").forEach((link) => {
  link.addEventListener("click", () => {
    globalNav.classList.remove("is-open");
    navBtn.classList.remove("is-open");
  });
});
/* ================================================================================ */
/** ====================================
 * kv ふわっとswiper
 * */
window.addEventListener("load", () => {
  const speed = 3000;
  const kvSwiper = new Swiper(".kvSwiper", {
    loop: true,
    speed: speed,
    autoplay: {
      delay: speed,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
  });
});
/* ================================================================================ */
/** ====================================
 * scrollTriggerスライダー
 * */
function initScrollTriggerSlides() {
  if (window.innerWidth <= 699) return;

  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

  const scrollTriggerSlides = document.querySelectorAll(".scrollTrigger-item");

  scrollTriggerSlides.forEach((section, index) => {
    const scrollTriggerSlidesInner = document.querySelectorAll(
      ".scrollTrigger-item-inner"
    );
    const pin = section.querySelector(".scrollTrigger-item-inner");

    const isLast = index === scrollTriggerSlides.length - 1;
    const isFIrst = index === 0;

    ScrollTrigger.create({
      trigger: section,
      start: "bottom bottom",
      end: () => `+=${section.getBoundingClientRect().height}`,

      onEnter: () => {
        scrollTriggerSlidesInner.forEach((el, i) => {
          gsap.set(el, {
            zIndex: i + 1,
          });
        });

        gsap.set(pin, {
          position: "fixed",
          top: "auto",
          bottom: 0,
          left: 0,
        });

        if (isLast) {
          scrollTriggerSlidesInner.forEach((el) => {
            gsap.set(el, {
              position: "absolute",
              top: 0,
              bottom: "auto",
              left: 0,
            });
          });
        }
      },

      onLeave: () => {
        if (isLast) {
          gsap.set(pin, {
            position: "absolute",
            top: 0,
            bottom: "auto",
            left: 0,
          });
        }
      },

      onLeaveBack: () => {
        scrollTriggerSlidesInner.forEach((el, i) => {
          gsap.set(el, {
            zIndex: 3 - i,
            position: "absolute",
          });
        });

        gsap.set(pin, {
          position: "fixed",
          top: 0,
          bottom: "auto",
          left: 0,
        });

        if (isFIrst) {
          gsap.set(pin, {
            position: "absolute",
            top: 0,
            bottom: "auto",
            left: 0,
          });
        }
      },
    });
  });

  ScrollTrigger.refresh();
}

initScrollTriggerSlides();

// リサイズ時の再実行も同様に分岐
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill()); // 一度killしてから
    initScrollTriggerSlides();
  }, 300);
});
/* ================================================================================ */
/** ====================================
 * inview
 * */
$(function () {
  $(".inview").on("inview", function (event, isInView) {
    if (isInView) {
      const $this = $(this);
      setTimeout(function () {
        $this.stop().addClass("is-show");
      }, 250);
    }
  });
});
/* ================================================================================ */
/** ====================================
 * fix-ctaボタン隠し犬 繰り返し処理
 * */
function toggleHiddenDog() {
  const hiddenDog = document.querySelector(".c-fixed-cta-dog");
  if (!hiddenDog) return;

  hiddenDog.classList.add("is-appear");

  setTimeout(() => {
    hiddenDog.classList.remove("is-appear");
  }, 5000);
}
toggleHiddenDog();
window.setInterval(toggleHiddenDog, 10000);
/* ================================================================================ */
/** ====================================
 * 隠れプードル　inview
 * */
const hiddenPoodle = document.querySelector(".abs-poodles");
$(function () {
  $(hiddenPoodle).on("inview", function () {
    $(this).addClass("is-show");
  });
});
/* ================================================================================ */
/** ====================================
 * 野菜バウンドアニメーション
 * */
const boundVegetablesWrap = document.querySelector(".abs__bound-gif");
const boundVegetablesGif = $(".js-bound-movie");

$(window).on("scroll", function () {
  $(boundVegetablesWrap).each(function () {
    const $el = $(this);
    const rect = this.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    if (rect.top < windowHeight * 0.5 && !$el.hasClass("is-appear")) {
      $el.addClass("is-appear");
    }
  });
});
/* ================================================================================ */
/** ====================================
 * voice　矢印アニメーション
 * */
$(window).on("scroll", function () {
  $(".js-speechTriangle").each(function () {
    const $el = $(this);
    const rect = this.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // 60%の高さで発火
    if (rect.top < windowHeight * 0.4 && !$el.hasClass("is-active")) {
      $el.addClass("is-active");
    }
  });

  $(".js-sp__speechTriangle").each(function () {
    const $el = $(this);
    const rect = this.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // 50%の高さで発火
    if (rect.top < windowHeight * 0.5 && !$el.hasClass("is-active")) {
      $el.addClass("is-active");
    }
  });
});
/* ================================================================================ */
/** ====================================
 * voice　無限スライダー
 * */
$(".infinit-slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000,
  variableWidth: true,
  cssEase: "linear",
  pauseOnHover: false,
  pauseOnFocus: false,
});

/* ================================================================================ */
/** ====================================
 * アコーディオンメニュー
 * */
$(function () {
  $(".question").on("click", function () {
    const answer = $(this).next(".answer");

    $(".answer").not(answer).slideUp(300).removeClass("is-open");
    $(".question").not(this).removeClass("is-open");

    answer.slideToggle(300).toggleClass("is-open");
    $(this).toggleClass("is-open");
  });
});
/* ================================================================================ */
/** ====================================
 * スムーススクロール
 * */
// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".l-header");

//   function getHeaderHeight() {
//     return header ? header.offsetHeight : 0;
//   }

//   document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
//     anchor.addEventListener("click", function (e) {
//       e.preventDefault();
//       const href = anchor.getAttribute("href");
//       const target = document.getElementById(href.replace("#", ""));

//       if (target) {
//         setTimeout(() => {
//           const targetPosition =
//             target.getBoundingClientRect().top +
//             window.pageYOffset -
//             getHeaderHeight();

//           window.scrollTo({
//             top: targetPosition,
//             behavior: "smooth",
//           });

//           history.pushState(null, null, href);
//         }, 10);
//       }
//     });
//   });

//   window.addEventListener("load", () => {
//     if (window.location.hash) {
//       setTimeout(() => {
//         const target = document.getElementById(
//           window.location.hash.replace("#", "")
//         );
//         if (target) {
//           const targetPosition =
//             target.getBoundingClientRect().top +
//             window.pageYOffset -
//             getHeaderHeight();

//           window.scrollTo({
//             top: targetPosition,
//             behavior: "smooth",
//           });
//         }
//       }, 300);
//     }
//   });
// });
/* ================================================================================ */
/** ====================================
 * voice　sp__swiper
 * */
const voiceSwiper = new Swiper(".voice-swiper", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
});
/* ================================================================================ */
/** ====================================
 * scrollTriggerスライダー_sp
 * */
// const sections = document.querySelectorAll("[data-section]");
// sections.forEach((section) => {
//   const inner = section.querySelector("[data-section-inner]");

//   ScrollTrigger.create({
//     markers: 'true',
//     trigger: section,
//     start: "bottom bottom",
//     onEnter: () => {
//       gsap.set(inner, {
//         position: "fixed",
//         bottom: 0,
//       });
//     },
//     onLeaveBack: () => {
//       gsap.set(inner, {
//         position: "absolute",
//         bottom: "auto",
//       });
//     },
//   });
// });

// window.addEventListener("load", () => {
//   ScrollTrigger.refresh();
// });